module.exports = __webpack_public_path__ + "assets/img/1941591928118_.pic_hd.cdd77fe3.jpg";